import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const types = ['RCA', 'Conducente', 'Trasportato', 'Pedone', 'Bici', 'Auto', 'Infortunio sul lavoro', 'RC diversi', 'Rivalsa Ditta', 'RC professionale', 'Polizza infortuni'];

export default function Esportazioni() {
  const [filters, setFilters] = useState({ dal: '', al: '', tipo: '', stato: '', ricerca: '' });
  const [rows, setRows] = useState([]);
  const [stati, setStati] = useState([]);
  const [error, setError] = useState('');
  React.useEffect(() => { fetch('/api/workflow/stati').then(r => r.json()).then(setStati).catch(() => {}); }, []);
  const query = () => new URLSearchParams(Object.entries(filters).filter(([, value]) => value));
  const search = async event => {
    event?.preventDefault();
    setError('');
    try {
      const response = await fetch(`/api/reports/schede?${query()}`);
      if (!response.ok) throw new Error('Ricerca non riuscita');
      setRows(await response.json());
    } catch (e) { setError(e.message); }
  };
  const exportCsv = () => { const params = query(); params.set('formato', 'csv'); window.location.href = `/api/reports/schede?${params}`; };
  const update = event => setFilters({ ...filters, [event.target.name]: event.target.value });
  return <main className="page-container">
    <p><Link to="/">Home</Link> / Esportazioni</p><h1>Ricerca ed esportazione schede</h1>
    <form onSubmit={search}>
      <label>Creazione dal <input name="dal" type="date" value={filters.dal} onChange={update} /></label>{' '}
      <label>al <input name="al" type="date" value={filters.al} onChange={update} /></label>{' '}
      <label>Tipo <select name="tipo" value={filters.tipo} onChange={update}><option value="">Tutti</option>{types.map(value => <option key={value}>{value}</option>)}</select></label>{' '}
      <label>Stato <select name="stato" value={filters.stato} onChange={update}><option value="">Tutti</option>{stati.map(value => <option key={value}>{value}</option>)}</select></label>{' '}
      <label>Nome o numero <input name="ricerca" value={filters.ricerca} onChange={update} /></label>{' '}
      <button type="submit">Cerca</button>{' '}
      <button type="button" onClick={exportCsv}>Esporta CSV per Excel</button>{' '}
      <button type="button" onClick={() => { setFilters({ dal: '', al: '', tipo: '', stato: '', ricerca: '' }); setRows([]); }}>Pulisci</button>
    </form>
    {error && <p role="alert">{error}</p>}
    <p>{rows.length} schede trovate</p>
    <table><thead><tr><th>Numero</th><th>Tipo</th><th>Assistito</th><th>Stato</th><th>Creazione</th><th>Sinistro</th><th>Prescrizione</th></tr></thead>
      <tbody>{rows.map(row => <tr key={row.id}><td><Link to={`/pratica/${row.id}`}>{row.numero_progressivo}</Link></td><td>{row.tipo}</td><td>{row.cognome} {row.nome}</td><td>{row.stato}</td><td>{row.data_creazione}</td><td>{row.data_sinistro}</td><td>{row.scadenza_prescrizione}</td></tr>)}</tbody></table>
  </main>;
}
